import UserComments from './holders/UserComments'
import UserMedia from './holders/UserMedia'
import UserNews from './holders/UserNews'

export const userRouteEntities = [
  {
    path: 'home',
    component: UserNews,
    breadcrumbName: (t) => t('updates'),
  },
  // {
  //   path: 'activities',
  //   component: UserActivities,
  //   breadcrumbName: (t) => t('activities'),
  //   isInvisible: ({item, isSm}) => !!!isSm,
  // },
  {
    path: 'comments',
    component: UserComments,
    breadcrumbName: (t) => t('comments'),
  },
  {
    path: 'media',
    component: UserMedia,
    breadcrumbName: (t) => t('media'),
  },
]
